import React, { useEffect, useState } from "react";
import "./cartCard.scss";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

// Icon
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import CloseIcon from "@mui/icons-material/Close";
import cartStore from "../../store/cartStore";
import productStore from "../../store/productStore";
import { PRODUCT_IMAGE_URL } from "../../constant";
import { Link } from "react-router-dom";
import categoryStore from "../../store/categoryStore";
import authStore from "../../store/authStore";

const CartCard = ({ item }) => {
  const matches = useMediaQuery("(min-width:450px)");
  const CategoryStore = categoryStore();
  const CartStore = cartStore();
  const AuthStore = authStore();
  const ProductStore = productStore();
  const [categoryName, setCategoryName] = useState();
  const [openSizeDialog, setOpenSizeDialog] = useState(false);
  const [openColorDialog, setOpenColorDialog] = useState(false);
  const [myCartCardProduct, setMyCartCardProduct] = useState(null);
  const [howManyColor, setHowManyColor] = useState([]);
  const [sizeSelect, setSizeSelect] = useState(null);
  const [colorSelected, setColorSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    init();
    setColorAndSizeInit();
  }, []);

  const init = () => {
    if (ProductStore.mProduct) {
      ProductStore.mProduct.map((product) => {
        if (product._id === item.productID) {
          setMyCartCardProduct(product);
        }
      });
    }
  };

  const setColorAndSizeInit = () => {
    setSizeSelect(item.selectedSize);
    setColorSelected(item.selectedColor);
  };

  useEffect(() => {
    if (CategoryStore.category && myCartCardProduct) {
      CategoryStore.category.filter((category) => {
        return (
          category._id === myCartCardProduct.categoryID &&
          setCategoryName(category.categoryName)
        );
      });

      const how = [];
      for (let i = 1; i <= myCartCardProduct.howManyColor; i++) {
        how.push(i);
      }
      setHowManyColor(how);
    }
  }, [myCartCardProduct]);

  const handleCloseSizeDialog = () => {
    setOpenSizeDialog(false);
    setColorAndSizeInit();
  };

  const handleCloseColorDialog = () => {
    setOpenColorDialog(false);
    setColorAndSizeInit();
  };

  const removeToCart = () => {
    if (AuthStore.isLogged) {
      CartStore.signInRemove({ cartID: item._id });
    } else {
      CartStore.noSignInRemove({ productID: item.productID });
    }
  };
  return (
    <Stack className="cart-card" direction="row" spacing={2}>
      <div className="img-container">
        <Link
          // to={
          //   myCartCardProduct &&
          //   `/${categoryName}/${myCartCardProduct.productName}/${myCartCardProduct._id}/details`
          // }
          to={
            myCartCardProduct &&
            `/perfume/${myCartCardProduct?.productName?.toLowerCase().replace(/\s+/g, "-")}/${myCartCardProduct._id}/details`
          }
        >
          <img
            src={
              myCartCardProduct &&
              `${PRODUCT_IMAGE_URL}${myCartCardProduct.productImages[0]}`
            }
            alt={`product-${myCartCardProduct ? myCartCardProduct.productName : "img"}`}
          />
        </Link>
      </div>
      <Tooltip className="icon-btn" title="Remove">
        <IconButton onClick={removeToCart}>
          <CloseIcon className="icon" />
        </IconButton>
      </Tooltip>
      <div className="details-container">
        <h4 className="product-name">
          <p>{myCartCardProduct && myCartCardProduct.productName}</p>
        </h4>
        <p className="product-sub-description">
          {myCartCardProduct && myCartCardProduct.productSubDescription}
        </p>
        <Stack
          className="product-size-color"
          spacing={1}
          direction={matches ? "row" : "column"}
        >
          {item.selectedSize && (
            <>
              <div
                className="product-size item"
                onClick={() => setOpenSizeDialog(true)}
              >
                <p className="select-text">Size: {item.selectedSize}</p>{" "}
                <ArrowDropDownRoundedIcon className="icon" />
              </div>
              <Dialog
                open={openSizeDialog}
                onClose={handleCloseSizeDialog}
                className="dialog"
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle>Select Size</DialogTitle>
                <DialogContent>
                  <div className="dialog-content" style={{ marginTop: "10px" }}>
                    {myCartCardProduct &&
                      myCartCardProduct.productSizes.map((size) => (
                        <Chip
                          key={size}
                          sx={{ ml: "5px" }}
                          label={size}
                          variant={sizeSelect === size ? "filled" : "outlined"}
                          className="chip"
                          onClick={() => setSizeSelect(size)}
                        />
                      ))}
                  </div>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseSizeDialog}>Cancel</Button>
                  <LoadingButton
                    loading={loading}
                    onClick={async () => {
                      setLoading(true);
                      if (AuthStore.isLogged) {
                        await CartStore.signInUpdateSize({
                          _id: item._id,
                          size: sizeSelect,
                        });
                      } else {
                        await CartStore.noSignUpdateSize({
                          productID: item.productID,
                          size: sizeSelect,
                        });
                      }
                      setLoading(false);
                      handleCloseSizeDialog();
                    }}
                  >
                    Apply
                  </LoadingButton>
                </DialogActions>
              </Dialog>
            </>
          )}
          {item.selectedColor && item.selectedColor?.length > 0 && (
            <>
              <div
                className="product-size item"
                onClick={() => setOpenColorDialog(true)}
              >
                <p className="select-text">
                  Color: {item.selectedColor && item.selectedColor.toString()}
                </p>{" "}
                <ArrowDropDownRoundedIcon className="icon" />
              </div>
              <Dialog
                open={openColorDialog}
                onClose={handleCloseColorDialog}
                className="dialog"
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle>Select Color</DialogTitle>
                <DialogContent>
                  {howManyColor &&
                    howManyColor.map((i) => (
                      <Select
                        value={colorSelected[i - 1]}
                        fullWidth
                        sx={{ mb: "10px" }}
                        key={i}
                        onChange={(e) => {
                          const dataTemp = [...colorSelected];
                          dataTemp[i - 1] = e.target.value;
                          setColorSelected(dataTemp);
                        }}
                      >
                        {myCartCardProduct.productColors.map((color) => (
                          <MenuItem value={color} key={color}>
                            {color}
                          </MenuItem>
                        ))}
                      </Select>
                    ))}
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseColorDialog}>Cancel</Button>
                  <LoadingButton
                    loading={loading}
                    onClick={async () => {
                      setLoading(true);
                      if (AuthStore.isLogged) {
                        await CartStore.signInUpdateColor({
                          _id: item._id,
                          selectedColor: colorSelected,
                        });
                      } else {
                        await CartStore.noSignUpdateColor({
                          productID: item.productID,
                          color: colorSelected,
                        });
                      }
                      setLoading(false);
                      handleCloseColorDialog();
                    }}
                  >
                    Apply
                  </LoadingButton>
                </DialogActions>
              </Dialog>
            </>
          )}
        </Stack>
        <div className="product-qty">
          <IconButton
            onClick={() => {
              if (item.qty < 9) {
                if (AuthStore.isLogged) {
                  CartStore.signInUpdateQty({
                    _id: item._id,
                    qty: item.qty + 1,
                  });
                } else {
                  CartStore.noSignUpdateQty({
                    productID: item.productID,
                    qty: item.qty + 1,
                  });
                }
              }
            }}
          >
            <AddRoundedIcon className="icon" />
          </IconButton>
          <h4>{item.qty}</h4>
          <IconButton
            onClick={() => {
              if (item.qty > 1) {
                if (AuthStore.isLogged) {
                  CartStore.signInUpdateQty({
                    _id: item._id,
                    qty: item.qty - 1,
                  });
                } else {
                  CartStore.noSignUpdateQty({
                    productID: item.productID,
                    qty: item.qty - 1,
                  });
                }
              }
            }}
          >
            <RemoveRoundedIcon className="icon" />
          </IconButton>
        </div>
        <div className="product-price">
          {myCartCardProduct && myCartCardProduct.salePrice && (
            <div className="product-sale-price">
              ₹{myCartCardProduct && myCartCardProduct.salePrice}
            </div>
          )}

          <div
            className={`product-regular-price ${
              myCartCardProduct && myCartCardProduct.salePrice && "is-sale"
            } `}
          >
            ₹{myCartCardProduct && myCartCardProduct.regularPrice}
          </div>
        </div>
        <div className="return-available">
          <p>
            Delivery within{" "}
            <span>
              {myCartCardProduct && myCartCardProduct.deliverDays} days
            </span>{" "}
            and <span>2 days</span> return available
          </p>
        </div>
      </div>
    </Stack>
  );
};

export default CartCard;
